import { render, staticRenderFns } from "./tabSpecialGoodsUICustomLayout.vue?vue&type=template&id=a7a62caa&"
import script from "./tabSpecialGoodsUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabSpecialGoodsUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7a62caa')) {
      api.createRecord('a7a62caa', component.options)
    } else {
      api.reload('a7a62caa', component.options)
    }
    module.hot.accept("./tabSpecialGoodsUICustomLayout.vue?vue&type=template&id=a7a62caa&", function () {
      api.rerender('a7a62caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoodsUICustomLayout.vue"
export default component.exports